import actions from 'redux-auto'

// eslint-disable-next-line no-unused-vars
const ErrorReporter = store => next => action => {
  try {
    next(action)
  } catch (e) {
    actions.error.writeError({error: e})
  }
}

export default ErrorReporter
